export const wallKeys ={
  uuid: 'uuid',
  wallName: 'wall_name',
  wallLogo: 'wall_logo',
  description: 'description',
  wallUrl: 'wall_url',
  owner: 'owner',
  visitCount: 'visit_count',
  coverImageUrl: 'cover_image_url',
  wallImageUrl: 'wall_image_url',
  isPublished: 'is_published',
  isDarkModeEnabled: 'is_dark_mode_enabled',
  backgroundColor: 'background_color',
  ratingColor: 'rating_color',
  quotationColor: 'quotation_color',
  bandColor: 'band_color',
  inkColor: 'ink_color',
  scoreBlockColor: 'score_block_color',
  isDateTimeDisabled: 'is_date_time_disabled',

  isEngagementDisabled: 'is_engagement_disabled',
  isDarkThemeLogo: 'is_dark_theme_logo',
  isSmallSize: 'is_small_size',
  isLogoDisabled: 'is_logo_disabled',
  darkCardTheme: 'dark_card_theme',
  carouselAutoplay: 'carousel_autoplay',
  linkColor: 'link_color',
  planLevel: 'plan_level',
  affiliateParameter: 'affiliate_parameter',
  affiliateParameterKey: 'affiliate_parameter_key',
  highlightColor: 'highlight_color',
  widgetType: 'widget_type',
  isEnablePagination: 'is_enable_pagination',

  isHiddenCarouselDots: 'is_hidden_carousel_dots',
  isCarouselHeightNormalized: 'is_carousel_height_normalized',
  carouselArrowColor: 'carousel_arrow_color',
  carouselDotColor: 'carousel_dot_color',
  isEnableBannerReview: 'is_enable_banner_review',
  isEnableReviewSummary: 'is_enable_review_summary',
  isReviewSummaryDarkModeEnabled: 'is_review_summary_dark_mode_enabled',
  reviewSummaryText: 'review_summary_text',
  reviewSummaryKeyThemes: 'review_summary_key_themes',
  reviewSummaryTotalTestimonials: 'review_summary_total_testimonials',
  bannerReviewText: 'banner_review_text',
  averageRating: 'average_rating',
  alignBanner: 'align_banner',

  categories: 'categories',
  categoriesTranslations: 'categories_translations', // { original: translated } labels - filter requests still use the original value
  categoryTextColor: 'category_text_color',
  categoryBackgroundColor: 'category_background_color',
  activeCategoryTextColor: 'active_category_text_color',
activeCategoryBackgroundColor: 'active_category_background_color',

  loadMoreButtonColor: 'load_more_button_color',
  loadMoreTextColor: 'load_more_text_color',
  loadMoreButtonText: 'load_more_button_text', 
  loadMoreBorderColor: 'load_more_border_color',

  cardBackgroundColor: 'card_background_color',
  cardFontColor: 'card_font_color',
  cardBackgroundObject: 'cardBackgroundObject',
  shortenText: 'shorten_text',
  readMoreText: 'read_more_text',
  readLessText: 'read_less_text',

  fontStyle: 'font_style'

  }

export const DEFAULT_READ_MORE_TEXT = 'Read More'
export const DEFAULT_READ_LESS_TEXT = 'Read Less'

export const getFamewallBrandingUrl = (wall, ref = 'widget') => {
  const affiliateParameter = wall && wall[wallKeys.affiliateParameter];
  const affiliateParameterKey = wall && wall[wallKeys.affiliateParameterKey] === 'aff' ? 'aff' : 'via';
  return affiliateParameter ? `https://famewall.io?ref=${ref}&${affiliateParameterKey}=${encodeURIComponent(affiliateParameter)}` : `https://famewall.io?ref=${ref}`;
}
  
  export const WIDGET_TYPE = {
    DEFAULT_REVIEW_TYPE: 1,
    CENTRE_REVIEW_TYPE: 2,
    BIG_PICTURE_REVIEW_TYPE: 3,
    GRAPHIC_REVIEW_TYPE: 4,
    QUOTE_REVIEW_TYPE: 5,
    AWARD_WIDGET_TYPE: 6,
    QUOTE_TEXT_REVIEW_WIDGET_TYPE: 7,
    GREY_COLORED_WIDGET_TYPE: 8,

    // Studio card set. Mirrors WIDGET_TYPE in
    // famewall-React/src/constants/wall.constant.js and WALL_WIDGET_TYPE in
    // famewall-backend/data_access/entity/walls/wall.entity.js - the Joi rule
    // validates against those values, so the three lists must stay in sync.
    AURORA_GLASS_WIDGET_TYPE: 10,
    BROADSHEET_WIDGET_TYPE: 11,
    COLORBAND_WIDGET_TYPE: 12,
    TOPLINE_WIDGET_TYPE: 13,
    INK_BLOCK_WIDGET_TYPE: 14,
    PINBOARD_WIDGET_TYPE: 15,
    PRISM_EDGE_WIDGET_TYPE: 16,
    MEGAPHONE_WIDGET_TYPE: 17,
    SCORE_BLOCK_WIDGET_TYPE: 18,
    SPOTLIGHT_WIDGET_TYPE: 19

  }
  
export const AVERAGE_RATING_PLACEHOLDER = '{average_rating}';

export const TOTAL_COUNT_PLACEHOLDER = '{testimonials_count}'
  
  export const textColors = {
  black:{
          primary: '#111',
          secondary: 'rgba(0,0,0,0.5)'
  },
  light:{
          primary: 'hsla(0, 0%, 100%, 0.8)',
          secondary: 'hsla(0, 0%, 100%, 0.4)'
  }
  }
  
  export const cardColors = {
  dark: 'linear-gradient(-50deg,rgba(0,0,0,.94),rgba(0,0,0,.58) 100%)',
  light: 'linear-gradient(-50deg,rgba(255,255,255,.5),rgba(255,255,255,.95) 80%)'
  }
  
  export const wallBackgroundColorKeys = {
    value: 'value',
    backgroundImage: 'backgroundImage'
  }
  
  export const NullBackgroundImageValue = 8;
  
  export const wallBackgroundColorConstants= [
  {
    [wallBackgroundColorKeys.value]:0,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(160deg, rgb(204, 251, 252), rgb(197, 234, 254), rgb(189, 211, 255))'
  },{
    [wallBackgroundColorKeys.value]:1,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(310deg, rgb(214, 233, 255), rgb(214, 229, 255), rgb(209, 214, 255), rgb(221, 209, 255), rgb(243, 209, 255), rgb(255, 204, 245), rgb(255, 204, 223), rgb(255, 200, 199), rgb(255, 216, 199), rgb(255, 221, 199))'
  },
  {
    [wallBackgroundColorKeys.value]:2,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(150deg, rgb(255, 242, 158), rgb(255, 239, 153), rgb(255, 231, 140), rgb(255, 217, 121), rgb(255, 197, 98), rgb(255, 171, 75), rgb(255, 143, 52), rgb(255, 115, 33), rgb(255, 95, 20), rgb(255, 87, 15))'
  },{
    [wallBackgroundColorKeys.value]:3,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(345deg, rgb(211, 89, 255), rgb(228, 99, 255), rgb(255, 123, 247), rgb(255, 154, 218), rgb(255, 185, 208), rgb(255, 209, 214), rgb(255, 219, 219))'
  },{
    [wallBackgroundColorKeys.value]:4,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(150deg, rgb(0, 224, 245), rgb(31, 158, 255), rgb(51, 85, 255))'
  },{
    [wallBackgroundColorKeys.value]:5,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(150deg, rgb(95, 108, 138), rgb(48, 59, 94), rgb(14, 18, 38))'
  },{
    [wallBackgroundColorKeys.value]:6,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(150deg, rgb(0, 176, 158), rgb(19, 77, 93), rgb(16, 23, 31))'
  },{
    [wallBackgroundColorKeys.value]:7,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(330deg, rgb(255, 25, 125), rgb(45, 13, 255), rgb(0, 255, 179))'
  },{
    [wallBackgroundColorKeys.value]:8,
    [wallBackgroundColorKeys.backgroundImage]: 'none'
  },{
    [wallBackgroundColorKeys.value]: 9,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(90deg, hsla(358, 84%, 68%, 1) 0%, hsla(27, 91%, 58%, 1) 76%, hsla(41, 98%, 49%, 1) 100%)'
  },{
    [wallBackgroundColorKeys.value]: 10,
    [wallBackgroundColorKeys.backgroundImage]: 'linear-gradient(130deg, rgba(255,118,118,1) 35%, rgba(255,255,255,1) 100%)'
  }]
  
  export const wallBackgroundMap =(colorValue) => {
  
    switch(colorValue){
      case 0:
          return wallBackgroundColorConstants[0][wallBackgroundColorKeys.backgroundImage];
      case 1:
        return wallBackgroundColorConstants[1][wallBackgroundColorKeys.backgroundImage];
      case 2:
        return wallBackgroundColorConstants[2][wallBackgroundColorKeys.backgroundImage];
      case 3:
        return wallBackgroundColorConstants[3][wallBackgroundColorKeys.backgroundImage];
      case 4:
        return wallBackgroundColorConstants[4][wallBackgroundColorKeys.backgroundImage];
      case 5:
        return wallBackgroundColorConstants[5][wallBackgroundColorKeys.backgroundImage];
      case 6:
        return wallBackgroundColorConstants[6][wallBackgroundColorKeys.backgroundImage];
      case 7:
        return wallBackgroundColorConstants[7][wallBackgroundColorKeys.backgroundImage];
      case 8:
        return wallBackgroundColorConstants[8][wallBackgroundColorKeys.backgroundImage];
      case 9:
          return wallBackgroundColorConstants[9][wallBackgroundColorKeys.backgroundImage];
      case 10:
          return wallBackgroundColorConstants[10][wallBackgroundColorKeys.backgroundImage]
    }
  }
